import { PATIENT_FORM_VERSIONS } from '../constants';
import { extractNumberFromTemplateVersion } from '../utils';

export default function useHasAccessToJumpLogicV2(version: string) {
  const versionNumber = extractNumberFromTemplateVersion(version) ?? 0;

  return +versionNumber >= +PATIENT_FORM_VERSIONS.next;
}
